import apiClient from '../api.js';

// Capa de servicios del ranking de egresados (Quinto/Cuarto/Tercio Superior).
// Backend en capas: `UNICEN/modules/academico`.
//
//   GET /academico/ranking-egresados?id_gestion=&id_sede=&id_carrera=
//       -> { data: [ { unicodigo, id_plan_estudio, id_carrera, cod_carrera,
//                      carrera, matricula, paterno, materno, nombres,
//                      estudiante, sexo, tipo_documento, num_documento,
//                      ext_documento, materias_aprobadas_total,
//                      promedio_acumulado, promedio_vigesimal, posicion,
//                      total_participantes }, ... ] }
//
//       Egresados en esa gestión (completaron el plan hasta ahí, incompletos
//       antes), ordenados por promedio acumulado (criterio del Kardex) de
//       mayor a menor, con `posicion` y `total_participantes` por carrera ya
//       calculados. `id_carrera` es opcional (sin él trae todas las carreras
//       de la sede).
//
//   GET /academico/ranking-egresados/internado-rotatorio?id_gestion=&id_sede=&id_carrera=
//   GET /academico/ranking-egresados/egreso-internado?id_gestion=&id_sede=&id_carrera=
//       -> { data: [ { unicodigo, id_plan_estudio, promedio_grupo }, ... ] }
//
//       Solo Medicina (`id_carrera` obligatorio): promedio de Internado
//       Rotatorio, o de Internado Rotatorio + materias de Egreso. Una fila
//       por estudiante+plan; se combina con el ranking general por
//       `unicodigo`+`id_plan_estudio` en el frontend.
//
//       400 si falta algún parámetro obligatorio o no es numérico.
//
// Solo lectura.

const resource = '/academico/ranking-egresados';

const useRankingEgresadosApi = {
  listarRanking({ id_gestion, id_sede, id_carrera }) {
    return apiClient.get(resource, { params: { id_gestion, id_sede, id_carrera } });
  },
  listarPromedioInternadoRotatorio({ id_gestion, id_sede, id_carrera }) {
    return apiClient.get(`${resource}/internado-rotatorio`, { params: { id_gestion, id_sede, id_carrera } });
  },
  listarPromedioEgresoInternado({ id_gestion, id_sede, id_carrera }) {
    return apiClient.get(`${resource}/egreso-internado`, { params: { id_gestion, id_sede, id_carrera } });
  },
};

export default useRankingEgresadosApi;
